/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { listOrigins } from '../../../../services/hr/recruitment/originsApi';

// ---------------------------------------------------------------------------
// Seletor de origem de candidatura ("de onde o candidato veio"). Carrega o
// catálogo (GET /hr/recruitment/origins) no mount. Por padrão só as ativas
// (activeOnly) — para o cadastro/filtro. Renderiza só o <select>.
// ---------------------------------------------------------------------------

export default function OriginSelect({
   id,
   value,
   onChange,
   disabled = false,
   activeOnly = true,
   placeholder = 'Selecione…',
   invalid = false,
}) {
   const [origins, setOrigins] = useState([]);
   const [isLoading, setIsLoading] = useState(false);

   useEffect(() => {
      let ignore = false;
      setIsLoading(true);
      listOrigins(activeOnly ? { active: 1 } : {})
         .then((list) => {
            if (!ignore) setOrigins(list);
         })
         .catch(() => {
            if (!ignore) toast.error('Erro ao carregar as origens.');
         })
         .finally(() => {
            if (!ignore) setIsLoading(false);
         });
      return () => {
         ignore = true;
      };
   }, [activeOnly]);

   return (
      <select
         id={id}
         value={value ?? ''}
         onChange={(e) => onChange(e.target.value)}
         disabled={disabled || isLoading}
         aria-invalid={invalid || undefined}
      >
         <option value="">{isLoading ? 'Carregando…' : placeholder}</option>
         {origins.map((origin) => (
            <option key={origin.id} value={String(origin.id)}>
               {origin.name}
            </option>
         ))}
      </select>
   );
}

OriginSelect.propTypes = {
   id: PropTypes.string,
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onChange: PropTypes.func.isRequired,
   disabled: PropTypes.bool,
   activeOnly: PropTypes.bool,
   placeholder: PropTypes.string,
   invalid: PropTypes.bool,
};
